export const scrollableViewZIndex = 2;
export const NotEnoughDataMsg = 'Not enough data to load this page';
